<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal1" id="SalesClosingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('sale.month_end_processing') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-start mb-3">
            <div class="d-flex align-items-center">
              <span class="font-weight-bold text-nowrap mr-2">{{ translations('sale.month_selection') }}</span>
              <select class="custom-select" v-model="searchByMonth">
                <option selected>-</option>
                <option value="-1">{{ translations('sale.date_designation') }}</option>
                <option v-for="(m, i) in unclosedMonths" :key="i" :value="m">{{ m }}{{ translations('sale.month') }}</option>
              </select>
            </div>
            <div v-if="Number(searchByMonth) === -1" class="d-flex align-items-center ml-2">
              <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom" style="width:160px">
              <span class="mr-1 ml-1">〜</span>
              <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo" style="width:160px">
            </div>
            <div class="d-flex align-items-center" style="margin-left:auto">
              <span class="font-weight-bold">{{ translations('sale.total_amount') }}</span>
              <span class="ml-3">{{ grandTotal.toLocaleString() }}</span>
            </div>
          </div>
          <div class="table-scroll">
            <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input class="form-check-input" v-model="selectAll" type="checkbox" value="1" id="defaultCheck03">
                      <label class="form-check-label" for="defaultCheck03">{{ translations('sale.choice') }}</label>
                    </div>
                  </th>
                  <th>{{ translations('sale.closing_date') }}</th>
                  <th>{{ translations('sale.customer_name') }}</th>
                  <th>{{ translations('sale.purchase_total') }}</th>
                  <th>{{ translations('sale.billed_amount_this_time') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-if="openedSaleList.length > 0">
                  <template v-for="(item, i) in openedSaleList">
                    <tr :key="i">
                      <td>
                        <div class="form-check">
                          <input v-model="selectedItems" :value="item" class="form-check-input" type="checkbox" id="defaultCheck1">
                          <label class="form-check-label" for="defaultCheck1"></label>
                        </div>
                      </td>
                      <td>{{ $invoiceTools.formatDate(item.closing_at.substr(0,10)) }}</td>
                      <td>{{ item.client_name }}</td>
                      <td class="right">{{ (Number(item.total_amount_inctax)).toLocaleString() }}</td>
                      <td class="right">{{ (Number(item.total_amount_inctax) + Number(item.balance)).toLocaleString() }}</td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="6" class="text-center">{{ translations('sale.billed_amount_this_time') }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" @click="submitRequest()" class="btn btn-primary">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
export default {
  name: 'MonthTighteningProcess',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      searchByMonth: '',
      selectAll: 0,
      openedSaleList: [],
      grandTotal: 0,
      isSearching: false,
      selectedItems: [],
      unclosedMonths: [],
      isLoading: false,
      isShowStartEndAt: false,
      dateFrom: '',
      dateTo: '',
      tempDateField: ''
    }
  },
  watch: {
    searchByMonth (newVal) {
      if (newVal && Number(newVal) !== -1) {
        this.isShowStartEndAt = false
        this.loadOpenedSaleList()
      } else {
        this.isShowStartEndAt = true
      }
    },
    selectAll () {
      this._selectAll()
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  created () {
  },
  mounted () {
    window.$(this.$refs.vuemodal1).on('shown.bs.modal', this.getUnclosedMonths)
    window.$(this.$refs.vuemodal1).on('hidden.bs.modal', this.resetData)
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    resetData () {
      this.grandTotal = 0
      this.searchByMonth = ''
      this.openedSaleList = []
      this.selectedItems = []
      this.selectAll = 0
      this.unclosedMonths = []
      this.dateFrom = null
      this.dateTo = null
    },
    triggerDateFilter (source) {
      if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
        this.loadOpenedSaleList()
      }

      if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
        this.loadOpenedSaleList()
      }
    },
    async getUnclosedMonths () {
      this.isLoading = true
      try {
        let months = await this.$http.post(this.$api_url.sales_unclosed_months)
        let $data = this.$invoiceTools.prepareResult(months.data, 'months', 'SalesClosingModal:getUnclosedMonths')
        if ($data.success === true) {
          $data.data.forEach(uncloseMonth => {
            const year = uncloseMonth.substring(0, 4)
            const month = uncloseMonth.substring(5)
            this.unclosedMonths.push(year + this.translations('sale.year') + month)
          })
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        console.log('SalesClosingModal:getUnclosedMonths:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
        this.isLoading = false
      }
    },
    async loadOpenedSaleList () {
      try {
        let yearMonth = null
        let startAt = null
        let endAt = null
        if (Number(this.searchByMonth) !== -1) {
          yearMonth = this.searchByMonth.replace(this.translations('sale.year'), '-')
        } else {
          startAt = this.dateFrom
          endAt = this.dateTo

          if (!startAt || !endAt) {
            return
          }
        }

        this.isSearching = true
        let openedList = await this.$http.post(this.$api_url.sales_opened_list, { month: yearMonth, start_at: startAt, end_at: endAt })
        let $data = this.$invoiceTools.prepareResult(openedList.data, ['list', 'over_all_total'], 'SalesClosingModal:loadOpenedSaleList')
        if ($data.success === true) {
          this.grandTotal = $data.data.over_all_total
          this.openedSaleList = $data.data.list
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isSearching = false
      } catch (error) {
        this.isSearching = false
        console.log('SalesClosingModal:loadOpenedSaleList:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
      }
    },
    _selectAll () {
      if (this.selectAll) {
        this.selectedItems = this.openedSaleList
      } else {
        this.selectedItems = []
      }
    },
    async submitRequest () {
      try {
        let params = []

        let startAt = null
        if (Number(this.searchByMonth) === -1) {
          startAt = this.dateFrom

          if (!startAt) {
            this.$toastr.error(this.translations('sale.notice_select_start_date'), this.translations('common.error'))
            return
          }
        }

        this.selectedItems.forEach(item => {
          params.push({
            client_id: item.client_id,
            closing_at: item.closing_at
          })
        })

        if (params.length === 0) {
          this.$toastr.error(this.translations('sale.notice_select'), this.translations('common.error'))
          return
        }

        this.isLoading = true
        const close = await this.$http.post(this.$api_url.sales_close, { list: params, start_at: startAt })
        const $data = this.$invoiceTools.prepareResult(close.data, '', 'SalesClosingModal:submitRequest')
        if ($data.success === true) {
          this.$toastr.success(this.translations('sale.notice_operation_was_successful'), this.translations('common.success'))
          this.$refs.closeModal.click()
          setTimeout(() => {
            this.$emit('closed')
          }, 100)
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('SalesClosingModal:submitRequest:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
      }
    }
  }
}
</script>
